import { createRoute, useNavigate } from '@tanstack/solid-router'
import { appLayoutRoute } from '../app-layout.route'
import { ClustersPage } from '../../ClustersPage'
import { editorSearchSchema } from '../search-schemas'

// /clusters — список + редактор. Открытие редактора через search-параметры
// (?edit=N или ?new=1), не отдельные роуты — чтобы не размонтировать список
// (resource items, filterText) при переключении list↔editor.
// new имеет приоритет над edit (если оба заданы — открываем форму создания).
export const clustersRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/clusters',
  validateSearch: editorSearchSchema,
  component: ClustersRouteComponent,
})

function ClustersRouteComponent() {
  const search = clustersRoute.useSearch()
  const navigate = useNavigate()
  return (
    <ClustersPage
      clusterId={search().edit ?? null}
      create={search().new === 1}
      onOpen={(id) => navigate({ to: '/clusters', search: { edit: id } })}
      onCreate={() => navigate({ to: '/clusters', search: { new: 1 } })}
      onBack={() => navigate({ to: '/clusters', search: {} })}
    />
  )
}
